import { useI18n } from '../../shared/i18n/I18nProvider';
import { Outlet, Link } from 'react-router';
import { useSession, isActiveOwner } from '../../modules/auth';
import { EmptyState } from '../../shared/ui';
export function RequireOwner() {
  const { t } = useI18n();

  const { auth, logout } = useSession();
  // A multi-store user may not have a selected store until the chooser loads.
  const allowed = auth?.user.status === 'active' && isActiveOwner(auth.organization_member) && (!auth.session.store_id || isActiveOwner(auth.store_member));
  return allowed ? <Outlet /> : <main className="access-denied"><EmptyState title={t("Tài khoản chưa có quyền chủ cửa hàng")} description={t("Vui lòng sử dụng tài khoản owner đang hoạt động. Nếu vừa đổi quyền, hãy đăng nhập lại.")} action={<Link className="btn btn-primary" to="/login" onClick={() => { void logout().catch(() => {}); }}>{t("Trở về đăng nhập")}</Link>} /></main>;
}
